/// <reference types="vite-plugin-pwa/client" />
// Keeps the installed app on the latest deploy. The service worker serves the app shell from its cache, and a
// browser looks for a new sw.js only on a navigation (or once a day). A home-screen app on iOS is mostly resumed
// from the background, which is no navigation, so it kept the old version until it was reinstalled.
//
// Look for a new version on start and whenever the app comes back to the screen; while it is in the background,
// every hour. With registerType "autoUpdate" a new worker takes over at once and the page reloads into the new
// version — the checks run when the user has just opened or returned to the app, not in the middle of a form.
import { registerSW } from 'virtual:pwa-register';

const HOUR = 60 * 60 * 1000;

export function keepAppUpdated() {
  if (!('serviceWorker' in navigator)) return;
  registerSW({
    immediate: true,
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      const check = () => {
        if (navigator.onLine) registration.update().catch(() => {});
      };
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') check();
      });
      setInterval(() => {
        if (document.visibilityState === 'hidden') check();
      }, HOUR);
    },
  });
}
